var React = require('react');

function IconArrowDown2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow-down-2"},React.createElement("path",{"id":"vector","fillRule":"evenodd","clipRule":"evenodd","d":"M7.91074 15.7559C8.23618 16.0814 8.76382 16.0814 9.08926 15.7559L13.7559 11.0893C14.0814 10.7638 14.0814 10.2362 13.7559 9.91074C13.4305 9.58531 12.9028 9.58531 12.5774 9.91074L9.33333 13.1548V1.83333C9.33333 1.3731 8.96024 1 8.5 1C8.03976 1 7.66667 1.3731 7.66667 1.83333V13.1548L4.42259 9.91074C4.09715 9.58531 3.56951 9.58531 3.24408 9.91074C2.91864 10.2362 2.91864 10.7638 3.24408 11.0893L7.91074 15.7559Z","fill":"currentColor"})));
}

IconArrowDown2.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 17 17","fill":"none"};

module.exports = IconArrowDown2;

IconArrowDown2.default = IconArrowDown2;
